import {initParallaxSection} from "../components/parallax-section";

export function initMnedaliLanding() {
    if (!$('#mnedali_landing').length) return;

    initParallaxSection();
}
